// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"153":"edbe9759","638":"b832bc41","916":"31d6cfe0"}[chunkId] + ".chunk.css";
};